import { BrowserModule } from '@angular/platform-browser'
import { NgModule } from '@angular/core'

import { AngularFireModule } from 'angularfire2'
import { environment } from '../environments/environment'
import { AngularFireStorageModule } from 'angularfire2/storage'
import { AngularFirestoreModule } from 'angularfire2/firestore'

import { AppRoutingModule } from './app-routing.module'

import { AppComponent } from './app.component'
import { HelloComponent } from './hello/hello.component'
import { IpscComponent } from './ipsc/ipsc.component'
import { WorkComponent } from './work/work.component'
import { RunningComponent } from './running/running.component'
import { BackgroundDirective } from './background.directive'
import { GalleryComponent } from './ipsc/gallery.component'
import { ProjectInfoComponent } from './work/project-info.component'
import { ProjectComponent } from './work/project.component'


@NgModule({
  declarations: [
    AppComponent,
    HelloComponent,
    IpscComponent,
    WorkComponent,
    RunningComponent,
    BackgroundDirective,
    GalleryComponent,
    ProjectInfoComponent,
    ProjectComponent
  ],
  imports: [
    BrowserModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireStorageModule,
    AngularFirestoreModule,
    AppRoutingModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts